import axios from 'axios';

const instance = axios.create({
    // baseURL:'http://192.168.1.22:8080',    
    baseURL:'http://api.dev.ynsjj88.com',
    // baseURL:'https://api.ynsjj88.com',
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    }
});
const instance1 = axios.create({
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    }
});
export function post1(url, params) {
    return instance1.post(url, params);
}
export function post(url, params) {
    return instance.post(url, params);
}

export function get(url,params) {
    return instance.get(url,params);
}



// WEBPACK FOOTER //
// ./src/service/httpBase.js